import React, { useContext, useEffect } from 'react';
import { Row, Col, Divider } from 'antd';
import { ConfigContext } from '../../context/Config';
import Loading from '../Loading';
import Arca from './components/Arca';
import Paypal from './components/Paypal';
import Stripe, {
  redirectToPayment as stripeRedirect,
} from './components/Stripe';
import Omise, { redirectToPayment as omiseRedirect } from './components/Omise';
import { PaymentTypes } from '../../types';
import Text from '../Text';

import './Checkout.less';

export type Item = {
  title: string;
  price: string;
};

export type CheckoutProps = {
  items: Item[];
  totalTitle: string;
  totalPrice: string;
  paymentTypes: Array<PaymentTypes>;
  onPaymentSelect: (type: string) => void;
  response?: { [key: string]: any };
  loading: boolean;
  onError?: (message: string) => void;
};

const TCheckout: React.FC<CheckoutProps> = ({
  items = [],
  totalTitle,
  totalPrice,
  paymentTypes = [],
  onPaymentSelect,
  response,
  loading = false,
  onError = () => {},
}) => {
  const { translate } = useContext(ConfigContext);

  useEffect(() => {
    if (response) {
      switch (response.type) {
        case PaymentTypes.ARCA:
          window.location = response.redirect;
          break;
        case PaymentTypes.STRIPE:
          stripeRedirect(response, onError);
          break;
        case PaymentTypes.OMISE:
          omiseRedirect(response, onError);
          break;
        case PaymentTypes.PAYPAL:
          window.location = response.redirect;
          break;
        default:
          onError('Non Supported payment method for order checkout');
      }
    }
  }, [response]);

  return (
    <div className="t-checkout">
      {loading && <Loading overlay />}
      {items.map((item, index) => (
        <Row key={index} className="t-checkout-price">
          <Col span={15}>
            <Text rows={1} level={2} textColor="dark-100">
              <span className="t-title">{translate('Course Price')}</span>
            </Text>
          </Col>
          <Col span={9}>
            <Text rows={1} level={2} textColor="dark-100">
              <span className="t-price">{item.price}</span>
            </Text>
          </Col>
        </Row>
      ))}
      <Divider className="t-divider" />
      {totalTitle && (
        <Row className="t-checkout-total">
          <Col span={15}>
            <Text rows={1} level={2} textColor="primary" semiBold>
              <span className="t-title">{totalTitle}</span>
            </Text>
          </Col>
          <Col span={9}>
            <Text rows={1} level={2} textColor="primary" semiBold>
              <span className="t-price">{totalPrice}</span>
            </Text>
          </Col>
        </Row>
      )}
      <Divider className="t-divider" />
      <div className="t-payments-wrapper">
        {!paymentTypes.length && (
          <Text>{translate('ui.no.payments.text')}</Text>
        )}
        {!!paymentTypes.length && (
          <Text>{translate('ui.choose.payment.method')}</Text>
        )}
        {paymentTypes.map((item) => {
          switch (item) {
            case PaymentTypes.ARCA:
              return <Arca key={item} onSelect={onPaymentSelect} />;
            case PaymentTypes.STRIPE:
              return <Stripe key={item} onSelect={onPaymentSelect} />;
            case PaymentTypes.OMISE:
              return <Omise key={item} onSelect={onPaymentSelect} />;
            case PaymentTypes.PAYPAL:
              return <Paypal key={item} onSelect={onPaymentSelect} />;
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

export default TCheckout;
